import { useEffect } from "react";
import confetti from "@hiseb/confetti";
import Button from "@shared/v2/Button";
import Modal from "@shared/v2/Modal";
import TextButton from "@shared/v2/TextButton";
import Typography from "@shared/v2/Typography";
import { PrintSolidV6 } from "@shared/v2/Icomoon";
import { useWizardContext } from "./WizardContext";
import BusinessPlanSheet from "./BusinessPlanSheet";

const CompleteAndPrint = () => {
  const { onClose, year, shouldCelebrateCompletion } = useWizardContext();

  useEffect(() => {
    if (!shouldCelebrateCompletion) return;
    confetti();
  }, [shouldCelebrateCompletion]);

  return (
    <>
      <Modal.Header className="print:hidden" title={`You've set your business goals for ${year} 🎉`} />
      <Modal.Body className="tw-flex tw-flex-col tw-gap-[24px] print:hidden">
        <Typography>
          Congrats! You completed {year} business planning. Print your goal sheet to keep your plan
          top-of-mind all year long.
        </Typography>
        <Typography>
          You can adjust your goals as needed throughout the year. Goals can be updated manually from the{" "}
          <b>Goal Settings page</b> or by clicking <b>Help Me Set My Goals</b> again.
        </Typography>
        <Typography>
          We’ve saved the stats and other numbers used to set your goals just in case you want to make
          adjustments later.
        </Typography>
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-flex-col tw-justify-between tw-gap-[8px] print:hidden">
        <Button
          size="medium"
          className="tw-inline-flex tw-justify-center tw-items-center tw-gap-[6px]"
          onClick={() => window.print()}
        >
          Print Goal Sheet <PrintSolidV6 />
        </Button>
        <TextButton onClick={onClose}>Close</TextButton>
      </Modal.Footer>
      <BusinessPlanSheet />
    </>
  );
};

export default CompleteAndPrint;
